// progressTracking.js
import { useState, useEffect } from 'react';
import {
    SECTION_WEIGHTS,
    REQUIRED_FIELDS,
    VALIDATION_RULES,
    TOTAL_WEIGHT
} from '../config/formConfig';

/**
 * Calculates completion percentage for a single field
 * Applies validation rules and returns a normalized score
 */
export const calculateFieldCompletion = (value, fieldName, rules = ['required']) => {
    // Early return for empty values
    if (!value && value !== 0) return 0;

    // Apply validation rules and calculate average completion
    const validations = rules.map(rule => {
        if (typeof rule === 'function') {
            return rule(value) ? 1 : 0;
        }
        return VALIDATION_RULES[rule](value) ? 1 : 0;
    });

    return validations.reduce((sum, v) => sum + v, 0) / validations.length;
};

/**
 * Calculates weighted progress for a form section
 * Handles both object and array-type sections
 */
// export const calculateSectionProgress = (sectionData, sectionName) => {
//     // Handle invalid input
//     if (!sectionData || typeof sectionData !== 'object') return 0;
//
//     // Get required fields for this section
//     const requiredFields = REQUIRED_FIELDS[sectionName];
//     if (!requiredFields) return 0;
//
//     if (!Array.isArray(sectionData)) {
//         Object.keys(requiredFields).forEach(field => {
//             if (!(field in sectionData)) {
//                 sectionData[field] = '';
//             }
//         });
//     }
//
//     // Special handling for sections with empty required fields
//     if (Object.keys(requiredFields).length === 0 && !Array.isArray(sectionData)) {
//         // Calculate based on any filled fields
//         const formFields = Object.keys(sectionData).filter(key =>
//             key !== 'id' && key !== 'user_id' && !key.startsWith('_')
//         );
//
//         if (formFields.length === 0) return 0;
//
//         const filledFields = formFields.filter(field =>
//             sectionData[field] && sectionData[field].toString().trim() !== ''
//         );
//
//         return filledFields.length / formFields.length;
//     }
//
//     // Handle array sections (training, medical)
//     if (Array.isArray(sectionData)) {
//         if (sectionData.length === 0) return 0;
//
//         // Calculate progress for each item in the array
//         const itemProgressValues = sectionData.map(item => {
//             let completedWeight = 0;
//             let totalWeight = 0;
//
//             // Only consider fields with weight 1.0 as required
//             Object.entries(requiredFields).forEach(([field, weight]) => {
//                 if (weight === 1.0) {
//                     totalWeight += weight;
//                     if (item[field] && item[field].toString().trim() !== '') {
//                         completedWeight += weight;
//                     }
//                 }
//             });
//
//             return totalWeight > 0 ? completedWeight / totalWeight : 0;
//         });
//
//         // Return average progress across all items
//         return itemProgressValues.reduce((sum, val) => sum + val, 0) / itemProgressValues.length;
//     }
//
//     // Handle object sections
//     let completedWeight = 0;
//     let totalWeight = 0;
//
//     // Only consider fields with weight 1.0 as required for completion
//     Object.entries(requiredFields).forEach(([field, weight]) => {
//         if (weight === 1.0) {
//             totalWeight += weight;
//             if (sectionData[field] && sectionData[field].toString().trim() !== '') {
//                 completedWeight += weight;
//             }
//         }
//     });
//
//
//
//     return totalWeight > 0 ? completedWeight / totalWeight : 0;
// };
/**
 * Calculates weighted progress for a form section
 * Handles both object and array-type sections with improved error handling
 */
// export const calculateSectionProgress = (sectionData, sectionName) => {
//     // Special handling for employment section
//     if (sectionName === 'employment') {
//         console.log(`Calculating progress for ${sectionName}:`, sectionData);
//     }
//
//     // Handle invalid input
//     if (!sectionData || typeof sectionData !== 'object') {
//         return 0;
//     }
//
//     // Get required fields for this section
//     const requiredFields = REQUIRED_FIELDS[sectionName];
//     if (!requiredFields) {
//         return 0;
//     }
//
//     // Handle empty objects specially - important for when data is deleted
//     if (!Array.isArray(sectionData) && Object.keys(sectionData).length === 0) {
//         if (sectionName === 'employment') {
//             console.log('Employment section is empty, returning 0');
//         }
//         return 0;
//     }
//
//     // For non-array data, ensure required fields are present
//     if (!Array.isArray(sectionData)) {
//         Object.keys(requiredFields).forEach(field => {
//             if (!(field in sectionData)) {
//                 sectionData[field] = '';
//             }
//         });
//     }
//
//     // Special handling for sections with empty required fields
//     if (Object.keys(requiredFields).length === 0 && !Array.isArray(sectionData)) {
//         // Calculate based on any filled fields
//         const formFields = Object.keys(sectionData).filter(key =>
//             key !== 'id' && key !== 'user_id' && !key.startsWith('_')
//         );
//
//         if (formFields.length === 0) return 0;
//
//         const filledFields = formFields.filter(field =>
//             sectionData[field] && sectionData[field].toString().trim() !== ''
//         );
//
//         return filledFields.length / formFields.length;
//     }
//
//     // Handle array sections (training, medical)
//     if (Array.isArray(sectionData)) {
//         if (sectionData.length === 0) return 0;
//
//         // Calculate progress for each item in the array
//         const itemProgressValues = sectionData.map(item => {
//             let completedWeight = 0;
//             let totalWeight = 0;
//
//             // Only consider fields with weight 1.0 as required
//             Object.entries(requiredFields).forEach(([field, weight]) => {
//                 if (weight === 1.0) {
//                     totalWeight += weight;
//                     if (item[field] && item[field].toString().trim() !== '') {
//                         completedWeight += weight;
//                     }
//                 }
//             });
//
//             return totalWeight > 0 ? completedWeight / totalWeight : 0;
//         });
//
//         // Return average progress across all items
//         return itemProgressValues.reduce((sum, val) => sum + val, 0) / itemProgressValues.length;
//     }
//
//     // Handle object sections with special focus on employment
//     let completedWeight = 0;
//     let totalWeight = 0;
//
//     // Log fields for debugging employment section only
//     if (sectionName === 'employment') {
//         console.log('Required fields for employment section:');
//         Object.entries(requiredFields).forEach(([field, weight]) => {
//             if (weight === 1.0) {
//                 console.log(`  ${field}: ${sectionData[field] || 'missing'}`);
//             }
//         });
//     }
//
//     // Check each required field
//     Object.entries(requiredFields).forEach(([field, weight]) => {
//         if (weight === 1.0) {
//             totalWeight += weight;
//
//             // Thorough checking for field values
//             const fieldValue = sectionData[field];
//             const fieldIsValid = fieldValue !== undefined &&
//                 fieldValue !== null &&
//                 fieldValue.toString().trim() !== '';
//
//             if (fieldIsValid) {
//                 completedWeight += weight;
//                 if (sectionName === 'employment') {
//                     console.log(`Field ${field} is complete with value: ${fieldValue}`);
//                 }
//             } else if (sectionName === 'employment') {
//                 console.log(`Field ${field} is incomplete with value: ${fieldValue}`);
//             }
//         }
//     });
//
//     const progress = totalWeight > 0 ? completedWeight / totalWeight : 0;
//
//     // Additional logging for employment section
//     if (sectionName === 'employment') {
//         console.log(`${sectionName} section progress: ${progress} (${completedWeight}/${totalWeight})`);
//     }
//
//     return progress;
// }

// Modify the calculateSectionProgress function in progressTracking.js to be more robust

/**
 * Robust version of calculateSectionProgress that prioritizes keeping valid data
 */
// In your progressTracking.js file, replace or modify the calculateSectionProgress function

// export const calculateSectionProgress = (sectionData, sectionName) => {
//     // Simple direct check for employment section
//     if (sectionName === 'employment') {
//         console.log(`Calculating progress for ${sectionName}:`, sectionData);
//
//         // CRITICAL: Check for {} empty object specifically for employment
//         if (sectionData && typeof sectionData === 'object' &&
//             Object.keys(sectionData).length === 0) {
//             console.log('Employment section is EMPTY OBJECT, returning 0');
//             return 0;
//         }
//     }
//
//
//     // Handle invalid input for other sections
//     if (!sectionData || typeof sectionData !== 'object') {
//         return 0;
//     }
//
//     // Get required fields for this section
//     const requiredFields = REQUIRED_FIELDS[sectionName];
//     if (!requiredFields) {
//         return 0;
//     }
//
//     // Handle array sections (training, medical)
//     if (Array.isArray(sectionData)) {
//         if (sectionData.length === 0) return 0;
//
//         // Calculate progress for each item in the array
//         const itemProgressValues = sectionData.map(item => {
//             let completedWeight = 0;
//             let totalWeight = 0;
//
//             // Only consider fields with weight 1.0 as required
//             Object.entries(requiredFields).forEach(([field, weight]) => {
//                 if (weight === 1.0) {
//                     totalWeight += weight;
//                     if (item[field] && item[field].toString().trim() !== '') {
//                         completedWeight += weight;
//                     }
//                 }
//             });
//
//             return totalWeight > 0 ? completedWeight / totalWeight : 0;
//         });
//
//         // Return average progress across all items
//         return itemProgressValues.reduce((sum, val) => sum + val, 0) / itemProgressValues.length;
//     }
//
//     // Handle object sections
//     let completedWeight = 0;
//     let totalWeight = 0;
//
//     // Check each required field
//     Object.entries(requiredFields).forEach(([field, weight]) => {
//         if (weight === 1.0) {
//             totalWeight += weight;
//
//             // Check if field exists and has value
//             const fieldValue = sectionData[field];
//             const fieldPresent = fieldValue !== undefined &&
//                 fieldValue !== null &&
//                 fieldValue.toString().trim() !== '';
//
//             if (fieldPresent) {
//                 completedWeight += weight;
//             }
//         }
//     });
//
//     const progress = totalWeight > 0 ? completedWeight / totalWeight : 0;
//     return progress;
// }


export const calculateSectionProgress = (sectionData, sectionName) => {
    // Simple direct check for employment section
    if (sectionName === 'employment') {
        console.log(`Calculating progress for ${sectionName}:`, sectionData);

        // CRITICAL: Check for {} empty object specifically for employment
        if (sectionData && typeof sectionData === 'object' &&
            Object.keys(sectionData).length === 0) {
            console.log('Employment section is EMPTY OBJECT, returning 0');
            return 0;
        }
    }

    // Handle invalid input for other sections
    if (!sectionData || typeof sectionData !== 'object') {
        return 0;
    }

    // Get required fields for this section
    const requiredFields = REQUIRED_FIELDS[sectionName];
    if (!requiredFields) {
        return 0;
    }

    // Handle array sections (training, medical)
    if (Array.isArray(sectionData)) {
        if (sectionData.length === 0) return 0;

        // Calculate progress for each item in the array
        const itemProgressValues = sectionData.map(item => {
            let completedWeight = 0;
            let totalWeight = 0;

            // Only consider fields with weight 1.0 as required
            Object.entries(requiredFields).forEach(([field, weight]) => {
                if (weight === 1.0) {
                    totalWeight += weight;
                    if (item[field] && item[field].toString().trim() !== '') {
                        completedWeight += weight;
                    }
                }
            });

            return totalWeight > 0 ? completedWeight / totalWeight : 0;
        });

        // Return average progress across all items
        return itemProgressValues.reduce((sum, val) => sum + val, 0) / itemProgressValues.length;
    }

    // Handle object sections
    let completedWeight = 0;
    let totalWeight = 0;

    // Special handling for identification_doc and staff_info sections - count all weighted fields
    if (sectionName === 'identification_doc' || sectionName === 'staff_info') {
        console.log(`Special progress calculation for ${sectionName}`);

        // For these sections, consider ALL weighted fields regardless of weight value
        Object.entries(requiredFields).forEach(([field, weight]) => {
            totalWeight += weight;

            // Check if field exists and has value
            const fieldValue = sectionData[field];
            const fieldPresent = fieldValue !== undefined &&
                fieldValue !== null &&
                fieldValue.toString().trim() !== '';

            if (fieldPresent) {
                completedWeight += weight;
                console.log(`Field ${field} is complete with value: ${fieldValue}`);
            } else {
                console.log(`Field ${field} is incomplete`);
            }
        });

        console.log(`${sectionName} progress: ${completedWeight}/${totalWeight}`);
    } else {
        // Original logic for other sections - only count weight 1.0 fields
        Object.entries(requiredFields).forEach(([field, weight]) => {
            if (weight === 1.0) {
                totalWeight += weight;

                // Check if field exists and has value
                const fieldValue = sectionData[field];
                const fieldPresent = fieldValue !== undefined &&
                    fieldValue !== null &&
                    fieldValue.toString().trim() !== '';

                if (fieldPresent) {
                    completedWeight += weight;
                }
            }
        });
    }

    const progress = totalWeight > 0 ? completedWeight / totalWeight : 0;
    return progress;
}
/**
 *
 *
 *
 *
 * Custom hook for managing form progress state
 * Provides total progress, section progress, and completion status
 */
// export const useFormProgress = (formData) => {
//     const [progress, setProgress] = useState(0);
//     const [sectionProgress, setSectionProgress] = useState({});
//     const [trigger, setTrigger] = useState(0);
//
//
//     // Update progress whenever form data changes
//     // useEffect(() => {
//     //     console.log('📊 useFormProgress received formData:', formData.employment);
//     //     // Calculate progress for each section
//     //     const newSectionProgress = {};
//     //     Object.keys(SECTION_WEIGHTS).forEach(section => {
//     //         newSectionProgress[section] = calculateSectionProgress(
//     //             formData[section],
//     //             section
//     //         );
//     //     });
//     //
//     //     // Calculate total weighted progress
//     //     let weightedProgress = 0;
//     //     Object.entries(SECTION_WEIGHTS).forEach(([section, weight]) => {
//     //         weightedProgress += newSectionProgress[section] * weight;
//     //     });
//     //
//     //     // Convert to percentage and round
//     //     const totalProgress = Math.round((weightedProgress / TOTAL_WEIGHT) * 100);
//     //
//     //     setSectionProgress(newSectionProgress);
//     //     setProgress(totalProgress);
//     // }, [formData]);
//     useEffect(() => {
//         console.log('📊 useFormProgress triggered with:', formData);
//
//         const newSectionProgress = {};
//         Object.keys(SECTION_WEIGHTS).forEach(section => {
//             newSectionProgress[section] = calculateSectionProgress(
//                 formData[section],
//                 section
//             );
//         });
//
//         let weightedProgress = 0;
//         Object.entries(SECTION_WEIGHTS).forEach(([section, weight]) => {
//             weightedProgress += newSectionProgress[section] * weight;
//         });
//
//         const totalProgress = Math.round((weightedProgress / TOTAL_WEIGHT) * 100);
//         setSectionProgress(newSectionProgress);
//         setProgress(totalProgress);
//     }, [formData, trigger]);  // <--- ✅ add trigger here
//
//     return {
//         totalProgress: progress,
//         sectionProgress,
//         isComplete: progress === 100
//     };
// };

// export const useFormProgress = (formData, progressKey) => {
//     const [progress, setProgress] = useState(0);
//     const [sectionProgress, setSectionProgress] = useState({});
//
//     useEffect(() => {
//         console.log('📊 useFormProgress triggered with key:', progressKey);
//         console.log('Current formData:', formData);
//
//         const newSectionProgress = {};
//         Object.keys(SECTION_WEIGHTS).forEach(section => {
//             const sectionProgress = calculateSectionProgress(
//                 formData[section],
//                 section
//             );
//             console.log(`Section ${section} progress:`, sectionProgress);
//             newSectionProgress[section] = sectionProgress;
//         });
//
//         let weightedProgress = 0;
//         Object.entries(SECTION_WEIGHTS).forEach(([section, weight]) => {
//             weightedProgress += newSectionProgress[section] * weight;
//         });
//
//         const totalProgress = Math.round((weightedProgress / TOTAL_WEIGHT) * 100);
//         console.log('Total progress calculated:', totalProgress);
//
//         setSectionProgress(newSectionProgress);
//         setProgress(totalProgress);
//     }, [formData, progressKey]);
//
//     return {
//         totalProgress: progress,
//         sectionProgress,
//         isComplete: progress === 100
//     };
// };

/**
 * Custom hook for managing form progress state
 * Provides total progress, section progress, and completion status
 * Fixed to handle updates to the employment section properly
 */
export const useFormProgress = (formData, progressKey) => {
    const [progress, setProgress] = useState(0);
    const [sectionProgress, setSectionProgress] = useState({});

    useEffect(() => {
        console.log('📊 useFormProgress triggered with key:', progressKey);

        // Deep clone to avoid reference issues
        const formDataCopy = JSON.parse(JSON.stringify(formData));

        console.log('Current formData for progress calculation:', formDataCopy);

        // Handle empty employment section correctly
        if (formDataCopy.employment && Object.keys(formDataCopy.employment).length === 0) {
            console.log('Empty employment object detected, ensuring it is processed correctly');
            // Keep it as an empty object - the calculateSectionProgress function will handle this
        }

        const newSectionProgress = {};
        Object.keys(SECTION_WEIGHTS).forEach(section => {
            const sectionProgress = calculateSectionProgress(
                formDataCopy[section],
                section
            );
            console.log(`Section ${section} progress:`, sectionProgress);
            newSectionProgress[section] = sectionProgress;
        });

        let weightedProgress = 0;
        Object.entries(SECTION_WEIGHTS).forEach(([section, weight]) => {
            weightedProgress += newSectionProgress[section] * weight;
        });

        const totalProgress = Math.round((weightedProgress / TOTAL_WEIGHT) * 100);
        console.log('Total progress calculated:', totalProgress);

        setSectionProgress(newSectionProgress);
        setProgress(totalProgress);
    }, [formData, progressKey]);

    return {
        totalProgress: progress,
        sectionProgress,
        isComplete: progress === 100
    };
};